// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610192312/js/" + chunkId + "." + {"44":"c845e714","225":"6989c43b","481":"e6db54de","486":"05dafdaa","770":"494e0bc7"}[chunkId] + ".0.4842553478100132.chunk.js";
};